var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGreenSemicircle = function SvgGreenSemicircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 154,
    height: 303,
    fill: "none",
    viewBox: "-3 0 151 303"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C3D870",
    d: "M-2.764 303H-4v-56.273h1.236c52.515 0 95.227-42.724 95.227-95.227S49.739 56.273-2.764 56.273H-4V0h1.236c83.532 0 151.5 67.956 151.5 151.5 0 83.532-67.955 151.5-151.5 151.5m1.236-53.813v51.328c81.604-.667 147.792-67.263 147.792-149.015 0-81.764-66.188-148.348-147.792-149.015v51.328c53.307.668 96.464 44.232 96.464 97.687.012 53.455-43.157 97.019-96.464 97.687"
  })));
};
export default SvgGreenSemicircle;